import React from 'react';

const NextPage = (): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.99975 1.55765e-06C5.25575 1.56884e-06 5.51175 0.0980021 5.70675 0.293002L12.7068 7.293C13.0978 7.684 13.0978 8.316 12.7068 8.707L5.70675 15.707C5.31575 16.098 4.68375 16.098 4.29275 15.707C3.90175 15.316 3.90175 14.684 4.29275 14.293L10.5858 8L4.29275 1.707C3.90175 1.316 3.90175 0.684002 4.29275 0.293002C4.48775 0.0980021 4.74375 1.54646e-06 4.99975 1.55765e-06Z"
    />
  </svg>
);

export default NextPage;
